import { useState } from "react";
import { X } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CreateUserModal({ onClose, onCreated }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await axios.post(`${API}/admin/users`, { name, email, password }, { withCredentials: true });
      toast.success("Customer created!");
      onCreated();
    } catch (err) {
      setError(err.response?.data?.detail || "Failed to create user");
    }
    setSubmitting(false);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" onClick={onClose}>
      <div
        data-testid="create-user-modal"
        className="w-full max-w-md rounded-xl border-2 border-[var(--c-border)] bg-[var(--c-surface)] p-6 shadow-[6px_6px_0px_var(--c-shadow)]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-5 flex items-center justify-between">
          <h2 className="font-heading text-xl font-bold text-[var(--c-text)]">Create Customer</h2>
          <button onClick={onClose} className="text-[var(--c-muted)] hover:text-[var(--c-text)]"><X className="h-5 w-5" /></button>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="mb-1 block text-xs font-bold uppercase tracking-[0.15em] text-[var(--c-muted)]">Full Name</label>
            <input data-testid="create-name-input" type="text" value={name} onChange={(e) => setName(e.target.value)} required
              className="w-full rounded-lg border-2 border-[var(--c-border)] bg-[var(--c-surface)] px-4 py-2.5 text-sm text-[var(--c-text)] focus:border-[#1E3A8A] focus:outline-none" placeholder="Jane Smith" />
          </div>
          <div>
            <label className="mb-1 block text-xs font-bold uppercase tracking-[0.15em] text-[var(--c-muted)]">Email</label>
            <input data-testid="create-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
              className="w-full rounded-lg border-2 border-[var(--c-border)] bg-[var(--c-surface)] px-4 py-2.5 text-sm text-[var(--c-text)] focus:border-[#1E3A8A] focus:outline-none" placeholder="jane@example.com" />
          </div>
          <div>
            <label className="mb-1 block text-xs font-bold uppercase tracking-[0.15em] text-[var(--c-muted)]">Password</label>
            <input data-testid="create-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6}
              className="w-full rounded-lg border-2 border-[var(--c-border)] bg-[var(--c-surface)] px-4 py-2.5 text-sm text-[var(--c-text)] focus:border-[#1E3A8A] focus:outline-none" placeholder="Min 6 characters" />
          </div>
          {error && <p className="text-sm font-medium text-[#FF4D4D]">{error}</p>}
          <button data-testid="create-user-submit" type="submit" disabled={submitting}
            className="flex w-full items-center justify-center gap-2 rounded-full border-2 border-[var(--c-border)] bg-[#1E3A8A] px-5 py-2.5 font-bold text-white shadow-[3px_3px_0px_var(--c-shadow)] transition-all hover:-translate-y-0.5 disabled:opacity-50">
            {submitting ? "Creating..." : "Create Customer"}
          </button>
        </form>
      </div>
    </div>
  );
}
